import * as universal from '../entries/pages/(app)/(marketing)/_layout.ts.js';

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/(marketing)/_layout.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/(app)/(marketing)/+layout.ts";
export const imports = ["_app/immutable/nodes/3.RnwxQCta.js","_app/immutable/chunks/NZTpNUN0.js","_app/immutable/chunks/DNEeYo6t.js","_app/immutable/chunks/Dg6_4QY_.js"];
export const stylesheets = ["_app/immutable/assets/3.D2hbYeP7.css"];
export const fonts = [];
